var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7532 0.953529C17.9484 0.758267 17.9484 0.441684 17.7532 0.246422C17.5579 0.0511601 17.2413 0.05116 17.0461 0.246422L8.99961 8.29287L0.953164 0.246422C0.757901 0.05116 0.441319 0.05116 0.246057 0.246422C0.0507946 0.441684 0.0507946 0.758267 0.246057 0.953529L8.2925 8.99998L0.246057 17.0464C0.0507937 17.2417 0.0507936 17.5583 0.246057 17.7535C0.441319 17.9488 0.757901 17.9488 0.953164 17.7535L8.99961 9.70708L17.0461 17.7535C17.2413 17.9488 17.5579 17.9488 17.7532 17.7535C17.9484 17.5583 17.9484 17.2417 17.7532 17.0464L9.70672 8.99998L17.7532 0.953529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.94cdc48372136ef3b9f0e221e1e36fb4.svg";
export { ForwardRef as ReactComponent };